import {SET_INFOS} from '../action/action';

const Infos = {
	hname: '',
	hmail: '',
	hautorisation: '',
	hnum: '',
	username: '',
	usermail: '',
	fonction: '',
	userstatus: '1'
}

const initialState = {
	infos: Infos
}

const setInfosReducer = (state = initialState, action) => {
	let nextState;

	switch (action.type) {
		case SET_INFOS: {
			nextState = {
				infos: action.value
			}
			return nextState || state
		}

		default:
			return state;
	}
}


export default setInfosReducer;